[
  {
    "passageId": "moses-1-39",
    "scenario": "A friend wonders whether their life matters to God. Which scripture could help you explain His purpose for us?",
    "options": [
      {
        "passageId": "moses-1-39",
        "reason": "Moses 1:39 directly names God’s purpose: bringing about our immortality and eternal life."
      },
      {
        "passageId": "genesis-1-26-27",
        "reason": "Genesis 1:26–27 can also support a conversation about worth because people are created in God’s image."
      },
      {
        "passageId": "psalm-24-3-4",
        "reason": "Psalm 24:3–4 concerns sincere worship and preparation, rather than directly stating God’s purpose for life."
      }
    ],
    "defensibleIds": [
      "moses-1-39",
      "genesis-1-26-27"
    ],
    "retryScenario": "After failing a test, a classmate says they must be a disappointment to God. Which passage could help them see His larger purpose for their life?"
  },
  {
    "passageId": "moses-7-18",
    "scenario": "Your class has formed separate groups and someone is often left out. Which passage could help you suggest a better way?",
    "options": [
      {
        "passageId": "moses-7-18",
        "reason": "Moses 7:18 describes Zion as one heart and one mind, with no poor among the people; inclusion follows naturally."
      },
      {
        "passageId": "exodus-20-3-17",
        "reason": "The Ten Commandments guide how we treat others, but do not give this passage’s specific picture of a united community."
      },
      {
        "passageId": "abraham-3-22-23",
        "reason": "Abraham 3:22–23 describes spirits organised before the world was, rather than how classmates can include one another."
      },
      {
        "passageId": "daniel-2-44-45",
        "reason": "Daniel 2:44–45 describes God’s enduring kingdom, rather than how classmates can include one another."
      }
    ],
    "defensibleIds": [
      "moses-7-18"
    ],
    "retryScenario": "A quorum is planning an activity, but two members cannot afford the cost. Which passage could guide the group’s response?"
  },
  {
    "passageId": "abraham-2-9-11",
    "scenario": "Someone thinks the covenant with Abraham is only about one ancient family. Which passage helps explain whom its blessings can reach?",
    "options": [
      {
        "passageId": "abraham-2-9-11",
        "reason": "Abraham 2:9–11 says those who receive the gospel are accounted Abraham’s seed and that all families of the earth can be blessed."
      },
      {
        "passageId": "isaiah-58-13-14",
        "reason": "Isaiah 58:13–14 concerns honouring the Sabbath, rather than who shares in Abraham’s covenant blessings."
      },
      {
        "passageId": "ezekiel-37-15-17",
        "reason": "Ezekiel 37:15–17 concerns two scriptural witnesses, rather than who shares in Abraham’s covenant blessings."
      },
      {
        "passageId": "genesis-2-24",
        "reason": "Genesis 2:24 describes a husband and wife becoming one, rather than the reach of Abraham’s covenant."
      }
    ],
    "defensibleIds": [
      "abraham-2-9-11"
    ],
    "retryScenario": "A friend asks whether gospel blessings promised to Abraham can reach people from many nations today. Which passage would you discuss?"
  },
  {
    "passageId": "abraham-3-22-23",
    "scenario": "A friend wonders whether our lives began at birth. What scripture could you use, and what does it actually teach?",
    "options": [
      {
        "passageId": "abraham-3-22-23",
        "reason": "Abraham 3:22–23 describes spirits before the world was, directly addressing life before birth."
      },
      {
        "passageId": "jeremiah-1-4-5",
        "reason": "Jeremiah 1:4–5 says the Lord knew Jeremiah before birth; it also helps, though it does not describe every person’s calling."
      },
      {
        "passageId": "genesis-1-26-27",
        "reason": "Genesis 1:26–27 describes people created in God’s image, but does not directly describe premortal life."
      }
    ],
    "defensibleIds": [
      "abraham-3-22-23",
      "jeremiah-1-4-5"
    ],
    "retryScenario": "A younger student asks if we existed as spirits before coming to earth. Which passage could help you answer?"
  },
  {
    "passageId": "genesis-1-26-27",
    "scenario": "A friend feels less valuable because they look different from others. Which scripture could help you speak about their worth?",
    "options": [
      {
        "passageId": "genesis-1-26-27",
        "reason": "Genesis 1:26–27 teaches that male and female are created in God’s image; it can support respectful treatment of a friend."
      },
      {
        "passageId": "moses-1-39",
        "reason": "Moses 1:39 gives God’s purpose for His children, another sound way to speak of their worth."
      },
      {
        "passageId": "genesis-39-9",
        "reason": "Genesis 39:9 describes Joseph refusing temptation, rather than the friend’s question about appearance and worth."
      }
    ],
    "defensibleIds": [
      "genesis-1-26-27",
      "moses-1-39"
    ],
    "retryScenario": "A student is mocked for a physical difference. Which passage could help the class remember how to regard every person?"
  },
  {
    "passageId": "genesis-2-24",
    "scenario": "Someone asks what the scriptures teach about unity in marriage. Which passage would you use, and how would you explain it kindly?",
    "options": [
      {
        "passageId": "genesis-2-24",
        "reason": "Genesis 2:24 teaches that a husband and wife cleave to each other and become one; explain this ideal without judging anyone’s family."
      },
      {
        "passageId": "moses-7-18",
        "reason": "Moses 7:18 describes a united community; its one heart and one mind can inform kindness, but it is not specifically about marriage."
      },
      {
        "passageId": "genesis-1-26-27",
        "reason": "Genesis 1:26–27 teaches that men and women are created in God’s image, rather than describing the husband-and-wife union named here."
      },
      {
        "passageId": "malachi-4-5-6",
        "reason": "Malachi 4:5–6 concerns family hearts and Elijah, rather than the husband-and-wife union named here."
      }
    ],
    "defensibleIds": [
      "genesis-2-24",
      "moses-7-18"
    ],
    "retryScenario": "A friend asks why a husband and wife should make their relationship a faithful partnership. Which passage could you share kindly?"
  },
  {
    "passageId": "genesis-39-9",
    "scenario": "Friends say a wrong choice is harmless if nobody finds out. What passage could help you explain your choice?",
    "options": [
      {
        "passageId": "genesis-39-9",
        "reason": "Genesis 39:9 shows Joseph rejecting a wrong act because it would be a sin against God, even apart from who might see it."
      },
      {
        "passageId": "joshua-24-15",
        "reason": "Joshua 24:15 can support choosing to serve the Lord despite others’ pressure."
      },
      {
        "passageId": "isaiah-29-13-14",
        "reason": "Isaiah 29:13–14 describes the Lord’s marvellous work and a wonder, rather than resisting a hidden wrong choice."
      },
      {
        "passageId": "ezekiel-37-15-17",
        "reason": "Ezekiel 37:15–17 concerns united scriptural witnesses, rather than resisting a hidden wrong choice."
      }
    ],
    "defensibleIds": [
      "genesis-39-9",
      "joshua-24-15"
    ],
    "retryScenario": "You have a chance to copy answers with no teacher nearby. Which passage could help you decide what to do?"
  },
  {
    "passageId": "exodus-20-3-17",
    "scenario": "A friend says commandments only stop people enjoying life. How could you use a commandment to explain a good it protects?",
    "options": [
      {
        "passageId": "exodus-20-3-17",
        "reason": "Exodus 20:3–17 gives commandments about worship and relationships; a student can explain the good one commandment protects."
      },
      {
        "passageId": "joshua-24-15",
        "reason": "Joshua 24:15 supports choosing to serve the Lord, though it does not list a commandment and its protected good."
      },
      {
        "passageId": "isaiah-58-13-14",
        "reason": "Isaiah 58:13–14 expands on the Sabbath commandment and the blessings of keeping it, so it can help explain a good a commandment protects."
      },
      {
        "passageId": "malachi-3-8-10",
        "reason": "Malachi 3:8–10 gives a specific invitation to pay tithing and promised blessings; it may be discussed as an example of trust, but not as one of the Ten Commandments."
      }
    ],
    "defensibleIds": [
      "exodus-20-3-17",
      "isaiah-58-13-14",
      "malachi-3-8-10"
    ],
    "retryScenario": "A friend asks how one of God’s commandments can protect trust between people. Which passage could you explore together?"
  },
  {
    "passageId": "joshua-24-15",
    "scenario": "Your friends want you to follow a choice that conflicts with your commitment to God. Which scripture could help you decide?",
    "options": [
      {
        "passageId": "joshua-24-15",
        "reason": "Joshua 24:15 calls for a deliberate choice to serve the Lord, even when others choose differently."
      },
      {
        "passageId": "genesis-39-9",
        "reason": "Genesis 39:9 gives Joseph’s example of refusing temptation out of loyalty to God."
      },
      {
        "passageId": "isaiah-29-13-14",
        "reason": "Isaiah 29:13–14 speaks of the Lord’s marvellous work, rather than choosing under peer pressure."
      }
    ],
    "defensibleIds": [
      "joshua-24-15",
      "genesis-39-9"
    ],
    "retryScenario": "Your group has chosen an activity that clashes with your decision to follow the Lord. Which passage could help you respond?"
  },
  {
    "passageId": "psalm-24-3-4",
    "scenario": "Someone asks why both outward actions and inward motives matter when preparing to worship. Which passage would help?",
    "options": [
      {
        "passageId": "psalm-24-3-4",
        "reason": "Psalm 24:3–4 pairs clean hands with a pure heart, connecting conduct and sincere desire in worship."
      },
      {
        "passageId": "isaiah-5-20",
        "reason": "Isaiah 5:20 warns against calling evil good and good evil; it does not directly pair actions with inward motives."
      },
      {
        "passageId": "isaiah-58-13-14",
        "reason": "Isaiah 58:13–14 invites delight in the Sabbath, but does not make the same hands-and-heart connection."
      }
    ],
    "defensibleIds": [
      "psalm-24-3-4"
    ],
    "retryScenario": "Someone prepares carefully for worship but wonders whether their intentions matter too. Which passage could help?"
  },
  {
    "passageId": "proverbs-3-5-6",
    "scenario": "You need to make a decision and cannot see how it will turn out. Which passage could help, and what might trusting the Lord look like?",
    "options": [
      {
        "passageId": "proverbs-3-5-6",
        "reason": "Proverbs 3:5–6 counsels trusting the Lord rather than only our understanding and acknowledging Him in our paths."
      },
      {
        "passageId": "joshua-24-15",
        "reason": "Joshua 24:15 addresses choosing whom to serve, but not especially trusting God amid an uncertain outcome."
      },
      {
        "passageId": "isaiah-1-18",
        "reason": "Isaiah 1:18 offers forgiveness of sins, rather than guidance for a decision with an uncertain outcome."
      },
      {
        "passageId": "daniel-2-44-45",
        "reason": "Daniel 2:44–45 describes a lasting kingdom, rather than guidance for a personal decision."
      }
    ],
    "defensibleIds": [
      "proverbs-3-5-6"
    ],
    "retryScenario": "You must choose between two good opportunities and cannot predict the result. Which passage invites you to seek the Lord’s direction?"
  },
  {
    "passageId": "isaiah-1-18",
    "scenario": "A friend feels that past mistakes make forgiveness impossible. Which scripture could help you offer hope in Jesus Christ?",
    "options": [
      {
        "passageId": "isaiah-1-18",
        "reason": "Isaiah 1:18 offers the Lord’s invitation to reason together and the hope that scarlet sins can become white."
      },
      {
        "passageId": "isaiah-53-3-5",
        "reason": "Isaiah 53:3–5 points to Christ bearing grief and being wounded for transgressions; it can also ground hope in Him."
      },
      {
        "passageId": "isaiah-5-20",
        "reason": "Isaiah 5:20 warns against moral reversal, but does not answer whether forgiveness is possible."
      }
    ],
    "defensibleIds": [
      "isaiah-1-18",
      "isaiah-53-3-5"
    ],
    "retryScenario": "Someone has repented but still believes they can never be clean from a past sin. Which passage could offer hope?"
  },
  {
    "passageId": "isaiah-5-20",
    "scenario": "An online trend presents cruelty as funny and kindness as weakness. Which scripture could help you examine that message?",
    "options": [
      {
        "passageId": "isaiah-5-20",
        "reason": "Isaiah 5:20 warns against calling evil good and good evil; changing a label does not settle whether cruelty is right."
      },
      {
        "passageId": "exodus-20-3-17",
        "reason": "Exodus 20:3–17 includes commandments about treating others rightly; it can help test the trend against God’s standards."
      },
      {
        "passageId": "proverbs-3-5-6",
        "reason": "Proverbs 3:5–6 is about trusting the Lord’s direction, rather than specifically reversing moral labels."
      }
    ],
    "defensibleIds": [
      "isaiah-5-20",
      "exodus-20-3-17"
    ],
    "retryScenario": "A popular video praises dishonesty as clever and calls honesty foolish. Which passage could help you evaluate that message?"
  },
  {
    "passageId": "isaiah-29-13-14",
    "scenario": "Someone asks why a restoration of the gospel was needed. How could this passage contribute to your explanation?",
    "options": [
      {
        "passageId": "isaiah-29-13-14",
        "reason": "Isaiah 29:13–14 calls the Lord’s latter-day work a marvellous work and a wonder; use it as part of an explanation of restoration."
      },
      {
        "passageId": "isaiah-5-20",
        "reason": "Isaiah 5:20 warns against calling evil good, rather than describing the Lord’s latter-day work."
      },
      {
        "passageId": "ezekiel-37-15-17",
        "reason": "Ezekiel 37:15–17 can contribute the Book of Mormon and Bible as united witnesses, one part of a restoration discussion."
      },
      {
        "passageId": "psalm-24-3-4",
        "reason": "Psalm 24:3–4 concerns preparing to stand in the Lord’s holy place, rather than explaining why a restoration was needed."
      },
      {
        "passageId": "daniel-2-44-45",
        "reason": "Daniel 2:44–45 prophesies an enduring kingdom; it does not by itself explain why restoration was needed."
      }
    ],
    "defensibleIds": [
      "isaiah-29-13-14",
      "ezekiel-37-15-17"
    ],
    "retryScenario": "A friend asks how the Lord described His latter-day work. Which passage could begin a discussion about the Restoration?"
  },
  {
    "passageId": "isaiah-53-3-5",
    "scenario": "A friend feels alone in grief and thinks nobody can understand. Which passage could you share, and why?",
    "options": [
      {
        "passageId": "isaiah-53-3-5",
        "reason": "Isaiah 53:3–5 describes the suffering Messiah acquainted with grief and bearing our sorrows, offering a reason to turn to Christ."
      },
      {
        "passageId": "isaiah-1-18",
        "reason": "Isaiah 1:18 offers hope of forgiveness from sin; that is different from directly speaking to grief."
      },
      {
        "passageId": "genesis-39-9",
        "reason": "Genesis 39:9 shows Joseph refusing to sin against God, rather than speaking to someone’s grief."
      },
      {
        "passageId": "malachi-3-8-10",
        "reason": "Malachi 3:8–10 invites tithing and promises blessings; it does not promise relief from grief."
      }
    ],
    "defensibleIds": [
      "isaiah-53-3-5"
    ],
    "retryScenario": "A grieving classmate says Christ cannot understand what they are feeling. Which passage could help you respond with care?"
  },
  {
    "passageId": "isaiah-58-6-7",
    "scenario": "Someone says fasting is just going without meals. Which passage could help you explain a fuller purpose?",
    "options": [
      {
        "passageId": "isaiah-58-6-7",
        "reason": "Isaiah 58:6–7 connects fasting with loosening burdens, sharing bread and caring for people in need."
      },
      {
        "passageId": "moses-7-18",
        "reason": "Moses 7:18 describes a community with no poor among them; it can support caring for others, though it does not teach fasting directly."
      },
      {
        "passageId": "isaiah-58-13-14",
        "reason": "Isaiah 58:13–14 concerns delighting in and honouring the Sabbath, a distinct subject in the same chapter."
      }
    ],
    "defensibleIds": [
      "isaiah-58-6-7",
      "moses-7-18"
    ],
    "retryScenario": "Your class is planning a fast and asks how to care for people in need alongside it. Which passage could guide the plan?"
  },
  {
    "passageId": "isaiah-58-13-14",
    "scenario": "A friend sees the Sabbath only as a list of restrictions. Which passage could help you discuss a positive purpose?",
    "options": [
      {
        "passageId": "isaiah-58-13-14",
        "reason": "Isaiah 58:13–14 calls the Sabbath a delight and invites us to honour the Lord in it."
      },
      {
        "passageId": "exodus-20-3-17",
        "reason": "Exodus 20:3–17 includes keeping the Sabbath holy; it can begin the discussion, though Isaiah emphasises delight."
      },
      {
        "passageId": "isaiah-58-6-7",
        "reason": "Isaiah 58:6–7 addresses fasting and care for people in need, rather than the Sabbath verses."
      }
    ],
    "defensibleIds": [
      "isaiah-58-13-14",
      "exodus-20-3-17"
    ],
    "retryScenario": "A friend wants a way to make Sunday feel meaningful instead of merely restrictive. Which passage could you discuss?"
  },
  {
    "passageId": "jeremiah-1-4-5",
    "scenario": "Someone asks whether God knew people before this life. What does the Lord’s call to Jeremiah help you explain?",
    "options": [
      {
        "passageId": "jeremiah-1-4-5",
        "reason": "Jeremiah 1:4–5 says the Lord knew Jeremiah before birth and appointed him a prophet; avoid assigning that same calling to everyone."
      },
      {
        "passageId": "abraham-3-22-23",
        "reason": "Abraham 3:22–23 describes spirits before the world was and also helps explain life before birth."
      },
      {
        "passageId": "psalm-24-3-4",
        "reason": "Psalm 24:3–4 concerns preparing to stand in the Lord’s holy place, rather than being known before birth."
      },
      {
        "passageId": "ezekiel-3-16-17",
        "reason": "Ezekiel 3:16–17 describes a prophet’s watchman responsibility, but not being known before birth."
      }
    ],
    "defensibleIds": [
      "jeremiah-1-4-5",
      "abraham-3-22-23"
    ],
    "retryScenario": "A student asks what the Lord told Jeremiah about his life before birth. Which passage gives the answer without assigning that calling to everyone?"
  },
  {
    "passageId": "ezekiel-3-16-17",
    "scenario": "A friend wonders why prophets sometimes give warnings that are difficult to hear. Which passage helps explain their responsibility?",
    "options": [
      {
        "passageId": "ezekiel-3-16-17",
        "reason": "Ezekiel 3:16–17 calls Ezekiel a watchman who hears the Lord’s word and warns the people."
      },
      {
        "passageId": "amos-3-7",
        "reason": "Amos 3:7 says the Lord reveals His purposes to prophets; that can help explain the source of prophetic counsel."
      },
      {
        "passageId": "daniel-2-44-45",
        "reason": "Daniel 2:44–45 describes God’s enduring kingdom, rather than a prophet’s duty to warn."
      }
    ],
    "defensibleIds": [
      "ezekiel-3-16-17",
      "amos-3-7"
    ],
    "retryScenario": "A friend dislikes a prophet’s warning and asks why prophets warn at all. Which passage describes that responsibility?"
  },
  {
    "passageId": "ezekiel-37-15-17",
    "scenario": "Someone asks why Latter-day Saints study the Book of Mormon alongside the Bible. Which doctrinal mastery passage could help?",
    "options": [
      {
        "passageId": "ezekiel-37-15-17",
        "reason": "Ezekiel 37:15–17 uses two sticks becoming one; the doctrinal mastery key phrase connects the Bible and Book of Mormon as united witnesses."
      },
      {
        "passageId": "isaiah-29-13-14",
        "reason": "Isaiah 29:13–14 speaks of a marvellous work and wonder, but does not directly name the two scriptural witnesses."
      },
      {
        "passageId": "exodus-20-3-17",
        "reason": "Exodus 20:3–17 gives commandments, rather than explaining the relation of the Bible and Book of Mormon."
      }
    ],
    "defensibleIds": [
      "ezekiel-37-15-17"
    ],
    "retryScenario": "A new student wonders how two books of scripture can witness together of Jesus Christ. Which passage could introduce the idea?"
  },
  {
    "passageId": "daniel-2-44-45",
    "scenario": "News about changing powers makes a friend wonder whether God’s work can last. What hope does this passage offer?",
    "options": [
      {
        "passageId": "daniel-2-44-45",
        "reason": "Daniel 2:44–45 prophesies a kingdom God establishes that will stand forever; avoid predicting dates from it."
      },
      {
        "passageId": "isaiah-29-13-14",
        "reason": "Isaiah 29:13–14 speaks of the Lord’s marvellous work, but does not directly contrast enduring and temporary kingdoms."
      },
      {
        "passageId": "malachi-3-8-10",
        "reason": "Malachi 3:8–10 teaches about tithing and blessings, rather than whether God’s kingdom endures."
      }
    ],
    "defensibleIds": [
      "daniel-2-44-45"
    ],
    "retryScenario": "Someone worries that changing governments could end God’s work. Which passage teaches about a kingdom that will endure?"
  },
  {
    "passageId": "amos-3-7",
    "scenario": "Someone asks why listening to prophets matters. Which passage could you use to explain their relationship to God?",
    "options": [
      {
        "passageId": "amos-3-7",
        "reason": "Amos 3:7 says the Lord reveals His purposes to His servants the prophets; He is the source of revelation."
      },
      {
        "passageId": "ezekiel-3-16-17",
        "reason": "Ezekiel 3:16–17 describes the prophet as a watchman who receives the Lord’s word and warns people."
      },
      {
        "passageId": "jeremiah-1-4-5",
        "reason": "Jeremiah 1:4–5 describes Jeremiah’s call before birth, rather than the general relationship asked about."
      }
    ],
    "defensibleIds": [
      "amos-3-7",
      "ezekiel-3-16-17"
    ],
    "retryScenario": "A friend asks where prophets receive the message they share. Which passage could help explain the Lord’s role?"
  },
  {
    "passageId": "malachi-3-8-10",
    "scenario": "A friend asks why paying tithing can be an act of trust. Which passage could you use without promising that faith guarantees wealth?",
    "options": [
      {
        "passageId": "malachi-3-8-10",
        "reason": "Malachi 3:8–10 invites tithing and promises blessings; the passage does not guarantee money or possessions."
      },
      {
        "passageId": "proverbs-3-5-6",
        "reason": "Proverbs 3:5–6 teaches trust in the Lord and can support the attitude behind a faithful choice, though it does not discuss tithing."
      },
      {
        "passageId": "malachi-4-5-6",
        "reason": "Malachi 4:5–6 concerns Elijah and family hearts, rather than tithing and its promised blessings."
      }
    ],
    "defensibleIds": [
      "malachi-3-8-10",
      "proverbs-3-5-6"
    ],
    "retryScenario": "A friend wants to understand why a person might pay tithing in faith without expecting to become rich. Which passage could you discuss?"
  },
  {
    "passageId": "malachi-4-5-6",
    "scenario": "Someone wonders how learning about ancestors connects with the gospel. Which passage could help you begin an explanation?",
    "options": [
      {
        "passageId": "malachi-4-5-6",
        "reason": "Malachi 4:5–6 prophesies Elijah and hearts turning between children and fathers, opening a discussion of family history and temple work."
      },
      {
        "passageId": "genesis-2-24",
        "reason": "Genesis 2:24 teaches husband and wife to cleave to one another; it concerns a different family relationship."
      },
      {
        "passageId": "abraham-2-9-11",
        "reason": "Abraham 2:9–11 concerns covenant blessings reaching all nations, rather than Elijah turning family hearts."
      }
    ],
    "defensibleIds": [
      "malachi-4-5-6"
    ],
    "retryScenario": "A student asks why temple and family history work focuses on bonds across generations. Which passage could start that conversation?"
  }
]
